<template>
<div>
    <Breadcrumbs main="Admin" submain="Content" title="In their Own Words" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div style="display: flex; justify-content: space-between; gap: 8px;">
                            <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add New</h7>
                            </button>
                        </div>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="words_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(title)="data">
                                        <div style="max-width: 250px;">
                                            {{ data.item?.title }}
                                        </div>
                                    </template>

                                    <template #cell(location)="data">
                                        <div style="max-width: 200px;">
                                            {{ data.item?.location?.name }}
                                        </div>
                                    </template>

                                    <template #cell(short_desc)="row">
                                        <div v-if="row.item.short_desc && row.item.short_desc.length > 200" style="max-width: 400px;">
                                            <div v-html="row.item.short_desc.slice(0, 200) + '...'"></div>
                                        </div>
                                        <div v-else style="max-width: 400px;">
                                            <div v-html="row.item.short_desc"></div>
                                        </div>
                                    </template>

                                    <template #cell(image)="row">
                                        <div v-if="row.item.image">
                                            <img style="height: 100px; border-radius: 4px;" :src="host + row.item.image" alt="">
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteResearch(data.item.id)" title="Delete"></feather>
                                            </div>
                                            <div @click="editResearch(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Words Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Words" size="xl" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" v-model="item.title" placeholder="Enter title" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Location</label>
                        <select class="form-control digits" v-model="item.location">
                            <option v-for="(loc, index) in location" :key="index" :value="loc">{{ loc.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Short Description</label>
                        <b-form-textarea class="form-control" type="text" v-model="item.short_desc" placeholder="Enter short description" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <ckeditor :editor="editor" v-model="item.description" placeholder="Enter description"></ckeditor>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group px-3">
                    <label>Participant Image</label>
                    <div>
                        <img v-if="item.image" style="height: 80px; border-radius: 6px;" :src="item.image">
                        <input :class="item.image ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadParticipantImage">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group px-3">
                    <label>Banner Image</label>
                    <div>
                        <img v-if="item.banner" style="height: 80px; border-radius: 6px;" :src="item.banner">
                        <input :class="item.banner ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadBannerImage">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Words Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Words" size="xl" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" v-model="edit_item.title" placeholder="Enter title" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Location</label>
                        <select class="form-control digits" v-model="edit_item.location">
                            <option v-for="(loc, index) in location" :key="index" :value="loc">{{ loc.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Short Description</label>
                        <b-form-textarea class="form-control" type="text" v-model="edit_item.short_desc" placeholder="Enter short description" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <ckeditor :editor="editor" v-model="edit_item.description" placeholder="Enter description"></ckeditor>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group px-3">
                    <label>Participant Image</label>
                    <div>
                        <img v-if="show_image" style="height: 80px; border-radius: 6px;" :src="show_image">
                        <input :class="edit_item.image ? 'ml-2' : 'ml-2'" type="file" accept="image/*" @change="uploadParticipantImage2">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group px-3">
                    <label>Banner Image</label>
                    <div>
                        <img v-if="show_banner_image" style="height: 80px; border-radius: 6px;" :src="show_banner_image">
                        <input :class="edit_item.banner ? 'ml-2' : 'ml-2'" type="file" accept="image/*" @change="uploadBannerImage2">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Words Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this item?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../_helpers/host';
import loader from '../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
    components: {
        loader
    },

    data() {
        return {
            editor: ClassicEditor,
            host: myHost.host,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'location',
                    label: 'Location',
                    sortable: true
                },
                {
                    key: 'short_desc',
                    label: 'Short Description',
                    sortable: true
                },
                {
                    key: 'image',
                    label: 'Participant',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            item: {
                title: '',
                location: '',
                short_desc: '',
                description: '',
                image: null,
                banner: null
            },

            edit_item: {
                id: '',
                title: '',
                location: '',
                short_desc: '',
                description: '',
                image: null,
                banner: null
            },

            delete_value: null,
            show_image: null,
            show_banner_image: null,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20]
        };
    },

    computed: {
        ...mapState({
            words_list: state => state.words.words,
            location: state => state.words.location,
            loading: state => state.words.wordsLoading,
            error: state => state.words.wordsError
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        this.$store.dispatch("words/fetchLocation")
        this.$store.dispatch("words/fetchWords").then(() => {
            this.items = this.words_list
            this.totalRows = this.words_list.length;
        });
    },

    methods: {
        uploadParticipantImage(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.item.image = e.target.result
            };
        },

        uploadParticipantImage2(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.edit_item.image = e.target.result
                this.show_image = e.target.result
            };
        },

        uploadBannerImage(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.item.banner = e.target.result
            };
        },

        uploadBannerImage2(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.edit_item.banner = e.target.result
                this.show_banner_image = e.target.result
            };
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.item = {
                title: '',
                location: '',
                short_desc: '',
                description: '',
                image: null,
                banner: null
            };
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("words/addWords", {
                item: this.item
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editResearch(detail) {
            this.edit_item = {
                id: detail.id || null,
                title: detail.title || null,
                short_desc: detail.short_desc || null,
                location: detail ?.location || null,
                description: detail.description || null,
            };
            this.show_image = this.host + detail.image || null
            this.show_banner_image = this.host + detail.banner || null
        },

        resetEditModal() {
            this.edit_item = {
                id: '',
                title: '',
                location: '',
                short_desc: '',
                description: '',
                image: null,
                banner: null
            };
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("words/updateWords", {
                id: this.edit_item.id,
                item: this.edit_item
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deleteResearch(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("words/deleteWords", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
